'use strict';

var requirePromise = require('./requirePromise');

requirePromise();

var IsCallable = require('es-abstract/2018/IsCallable');

var SpeciesConstructor = require('es-abstract/2018/SpeciesConstructor');

var Type = require('es-abstract/2018/Type');

var promiseResolve = function PromiseResolve(C, value) {
  return new C(function (resolve) {
    resolve(value);
  });
};

var OriginalPromise = Promise;

var createThenFinally = function CreateThenFinally(C, onFinally) {
  return function (value) {
    var result = onFinally();
    var promise = promiseResolve(C, result);

    var valueThunk = function valueThunk() {
      return value;
    };

    return promise.then(valueThunk);
  };
};

var createCatchFinally = function CreateCatchFinally(C, onFinally) {
  return function (reason) {
    var result = onFinally();
    var promise = promiseResolve(C, result);

    var thrower = function thrower() {
      throw reason;
    };

    return promise.then(thrower);
  };
};

var promiseFinally = function finally_(onFinally) {
  /* eslint no-invalid-this: 0 */
  var promise = this;

  if (Type(promise) !== 'Object') {
    throw new TypeError('receiver is not an Object');
  }

  var C = SpeciesConstructor(promise, OriginalPromise); // may throw

  var thenFinally = onFinally;
  var catchFinally = onFinally;

  if (IsCallable(onFinally)) {
    thenFinally = createThenFinally(C, onFinally);
    catchFinally = createCatchFinally(C, onFinally);
  }

  return promise.then(thenFinally, catchFinally);
};

if (Object.getOwnPropertyDescriptor) {
  var descriptor = Object.getOwnPropertyDescriptor(promiseFinally, 'name');

  if (descriptor && descriptor.configurable) {
    Object.defineProperty(promiseFinally, 'name', {
      configurable: true,
      value: 'finally'
    });
  }
}

module.exports = promiseFinally;